import { Injectable, inject } from '@angular/core';

import { InAppReview } from '@capacitor-community/in-app-review';
import { StorageService } from 'src/app/@core/storage.service';

const SHOW_POPUP_INTERVAL: number = 4;
const LEAST_APP_STARTS_TO_SHOW_POPUP: number = 10;
const MONTHS_OF_YEAR: number = 12;

@Injectable({
  providedIn: 'root',
})
export class RatingService {
  private storage = inject(StorageService);

  public showRating(): void {
    const currentDate: Date = new Date();
    const appStarts: number = this.storage.get('appStarts');
    const lastRatingPopupDate: string = this.storage.get('lastRatingPopupDate', null);
    const lastRatingPopupAsDate: Date = new Date(lastRatingPopupDate);

    if (appStarts < LEAST_APP_STARTS_TO_SHOW_POPUP) {
      return;
    }

    // show popup for the first time
    if (appStarts % LEAST_APP_STARTS_TO_SHOW_POPUP === 0 && lastRatingPopupDate === null) {
      this.showAndUpdate(currentDate).catch();

      return;
    }

    // show popup in interval
    if (this.getMonthDifference(lastRatingPopupAsDate, currentDate) >= SHOW_POPUP_INTERVAL) {
      this.showAndUpdate(currentDate).catch();
    }
  }

  // call rate plugin, update lastRatingPopupDate only if plugin was shown successfully
  private async showAndUpdate(currentDate: Date): Promise<void> {
    try {
      await InAppReview.requestReview();

      this.storage.set('lastRatingPopupDate', currentDate.toISOString());
    } catch (err) {
      console.error('An error occurred:', err);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  private getMonthDifference(date1: Date, date2: Date): number {
    // eslint-disable-next-line no-mixed-operators
    return (date2.getFullYear() - date1.getFullYear()) * MONTHS_OF_YEAR + (date2.getMonth() - date1.getMonth());
  }
}
